import React, {useMemo} from 'react';

import {FeaturesEnum} from 'presentation/constants';
import {useFeatureFlag} from 'presentation/hooks/useFeatureFlag';
import {getTelehealthStepPosition} from 'presentation/modules/booking/telehealth/utils/getTelehealthStepPosition';
import {TelehealthBookingStepsProps} from './types';
import {TelehealthSpecialtySelection} from '../TelehealthSpecialtySelection';
import {TelehealthProfessionalSelection} from '../TelehealthProfessionalSelection';
import {TelehealthReviewBooking} from '../TelehealthReviewBooking';
import {TelehealthReviewBookingNew} from '../TelehealthReviewBookingNew';

export function TelehealthStepsWrapper({
	activeStep,
	handleBack,
	handleNext,
	stepLabels,
}: TelehealthBookingStepsProps) {
	const stepPositions = useMemo(() => getTelehealthStepPosition(), []);
	const {isEnabled: isNewResumePageEnabled} = useFeatureFlag(
		FeaturesEnum.PORTAL_FEATURE_NEW_RESUME_BOOKING_PAGE,
	);

	const {SPECIALITY_OR_EXAM_STEP, PROFESSIONAL_STEP, REVIEW_STEP} = stepPositions;

	const stepContent = useMemo(() => {
		const baseSteps: Record<number, JSX.Element | null> = {
			[SPECIALITY_OR_EXAM_STEP]: <TelehealthSpecialtySelection handleNextStep={handleNext} />,
			[PROFESSIONAL_STEP]: <TelehealthProfessionalSelection handleNextStep={handleNext} />,
			[REVIEW_STEP]: isNewResumePageEnabled ? (
				<TelehealthReviewBookingNew handlePrevStep={handleBack} />
			) : (
				<TelehealthReviewBooking stepLabels={stepLabels} handlePrevStep={handleBack} />
			),
		};

		return baseSteps;
	}, [
		SPECIALITY_OR_EXAM_STEP,
		PROFESSIONAL_STEP,
		REVIEW_STEP,
		isNewResumePageEnabled,
		handleNext,
		handleBack,
		activeStep,
		stepLabels,
	]);

	return stepContent[activeStep] ?? null;
}
